function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

import { monitor, monitorError } from '../tools/monitor';
import { isExperimentalFeatureEnabled, ExperimentalFeature } from '../tools/experimentalFeatures';
import { Observable } from '../tools/observable';
import { newRetryState, sendWithRetryStrategy } from './sendWithRetryStrategy';
export function createHttpRequest(endpointBuilders, bytesLimit, reportError) {
  var observable = new Observable();
  var retryState = newRetryState();
  return {
    observable: observable,
    send: function send(payload) {
      var _iterator = _createForOfIteratorHelper(endpointBuilders),
          _step;

      try {
        var _loop = function _loop() {
          var endpointBuilder = _step.value;
          sendWithRetryStrategy(payload, retryState, function (payload, onResponse) {
            if (isExperimentalFeatureEnabled(ExperimentalFeature.AVOID_FETCH_KEEPALIVE)) {
              fetchStrategy(endpointBuilder, payload, onResponse);
            } else {
              fetchKeepAliveStrategy(endpointBuilder, bytesLimit, payload, onResponse);
            }
          }, endpointBuilder.trackType, reportError, observable);
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },

    /**
     * Since fetch keepalive behaves like regular fetch on Firefox,
     * keep using sendBeaconStrategy on exit
     */
    sendOnExit: function sendOnExit(payload) {
      var _iterator2 = _createForOfIteratorHelper(endpointBuilders),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var endpointBuilder = _step2.value;
          sendBeaconStrategy(endpointBuilder, bytesLimit, payload);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  };
}

function sendBeaconStrategy(endpointBuilder, bytesLimit, payload) {
  var canUseBeacon = !!navigator.sendBeacon && payload.bytesCount < bytesLimit;

  if (canUseBeacon) {
    try {
      var beaconUrl = endpointBuilder.build('beacon', payload);
      var isQueued = navigator.sendBeacon(beaconUrl, payload.data);

      if (isQueued) {
        return;
      }
    } catch (e) {
      reportBeaconError(e);
    }
  }

  fetchStrategy(endpointBuilder, payload);
}

var hasReportedBeaconError = false;

function reportBeaconError(e) {
  if (!hasReportedBeaconError) {
    hasReportedBeaconError = true;
    monitorError(e);
  }
}

export function fetchKeepAliveStrategy(endpointBuilder, bytesLimit, payload, onResponse) {
  var canUseKeepAlive = isKeepAliveSupported() && payload.bytesCount < bytesLimit;

  if (canUseKeepAlive) {
    var fetchUrl = endpointBuilder.build('fetch-keepalive', payload);
    fetch(fetchUrl, {
      method: 'POST',
      body: payload.data,
      keepalive: true,
      mode: 'cors'
    }).then(monitor(function (response) {
      return onResponse === null || onResponse === void 0 ? void 0 : onResponse({
        status: response.status,
        type: response.type
      });
    }))["catch"](monitor(function () {
      return fetchStrategy(endpointBuilder, payload, onResponse);
    }));
  } else {
    fetchStrategy(endpointBuilder, payload, onResponse);
  }
}
export function fetchStrategy(endpointBuilder, payload, onResponse) {
  var fetchUrl = endpointBuilder.build('fetch', payload);
  fetch(fetchUrl, {
    method: 'POST',
    body: payload.data,
    mode: 'cors'
  }).then(monitor(function (response) {
    return onResponse === null || onResponse === void 0 ? void 0 : onResponse({
      status: response.status,
      type: response.type
    });
  }))["catch"](monitor(function () {
    return onResponse === null || onResponse === void 0 ? void 0 : onResponse({
      status: 0
    });
  }));
}

function isKeepAliveSupported() {
  // Request can throw, cf https://developer.mozilla.org/en-US/docs/Web/API/Request/Request#errors
  try {
    return window.Request && 'keepalive' in new Request('http://a');
  } catch (_a) {
    return false;
  }
}